import none from '../../img/leoLogo.png'
import montali from '../../img/moktel/montali.jpg'
import melone from '../../img/moktel/melon2.jpg'
import cocoblood from '../../img/moktel/cocoblood.jpg'
import santiago from '../../img/moktel/santiago.jpg'
import floriya from '../../img/moktel/floriya.jpg'
import pops from '../../img/moktel/spops.jpg'
import winio from '../../img/moktel/winio.jpg'


export const moktel=[
    // {
    //   "id": "121",
    //   "title": "dreamy ماکتل",
    //   "desciption": "پنیرک-سیروپ شاتوت-بلوکاراسوا-سودا",
    //   "price": "116",
    //   "image": none
    // },
    {
      "id": "122",
      "title": "لیموناد",
      "desciption": "لیمو-یخ-اسپرایت",
      "price": "195",
      "image": none
    },
    {
      "id": "123",
      "title": "مونتالی",
      "desciption": "بلوکاراسوا-سیروپ انبه-سیروپ پرتقال-الوورا-لیمو-اسپرایت",
      "price": "199",
      "image": montali
    },
    {
      "id": "124",
      "title": "ملونا",
      "desciption": "شاتوت-کرن بری-سودا-لیمو",
      "price": "195",
      "image": none
    },
    {
      "id": "125",
      "title": "بلوکاراسوا",
      "desciption": "لیمو-سیروپ نارگیل-بلوکاراسوا-اسپرایت",
      "price": "197",
      "image": none
    },
    // {
    //   "id": "126",
    //   "title": "دیلایتفول",
    //   "desciption": "پرتقال قرمز-لیمو-قهوه",
    //   "price": "115",
    //   "image": none
    // },
    {
      "id": "127",
      "title": "پینکی",
      "desciption": "کاکتوس-الوورا-اسپرایت",
      "price": "189",
      "image": none
    },
    {
      "id": "128",
      "title": "موهیتو",
      "desciption": "نعنا-سیروپ نعنا-لیمو-اسپرایت",
      "price": "199",
      "image": none
    },
    // {
    //   "id": "129",
    //   "title": "گرینو",
    //   "desciption": "سیرووپ سیب ترش-لیمو-سیروپ نعنا-اسپرایت",
    //   "price": "119",
    //   "image": none
    // },
    // {
    //   "id": "1210",
    //   "title": "تامکورد",
    //   "desciption": "انگور قرمز-لیمو-اسپرایت-سیروپ کرن بری",
    //   "price": "109",
    //   "image": none
    // },
    // {
    //   "id": "1211",
    //   "title": "ماکتل انار",
    //   "desciption": "آب انار-سیروپ کرن بری-لیمو-سودا",
    //   "price": "115",
    //   "image": none
    // },
    // {
    //   "id": "1212",
    //   "title": "ماکتل عشق",
    //   "desciption": "کاکتوس-سیروپ رزبری-پنیرک-لیمو",
    //   "price": "119",
    //   "image": none
    // },
    // {
    //   "id": "1213",
    //   "title": "ماراگاریتا توت فرنگی",
    //   "desciption": "توت فرنگی-لیمو-سودا",
    //   "price": "118",
    //   "image": none
    // },
    // {
    //   "id": "1214",
    //   "title": "پشن موهیتو",
    //   "desciption": "آب پرتقال-لیمو-شاتوت-سودا",
    //   "price": "118",
    //   "image": none
    // },
    // {
    //   "id": "1215",
    //   "title": "ماکتل لیدی بیوتیفول",
    //   "desciption": "بلوکاراسوا-لیمو-کاکتوس",
    //   "price": "135",
    //   "image": none
    // },
    {
      "id": "1216",
      "title": "آب میوه روز",
      "desciption": "",
      "price": "175",
      "image": none
    },
    // {
    //   "id": "1217",
    //   "title": "ماکتل روز",
    //   "desciption": "",
    //   "price": "130",
    //   "image": none
    // },
    {
      "id": "1218",
      "title": "رد بلو",
      "desciption": "کرن بری-آلبالو-بلوکاراسوا",
      "price": "199",
      "image": none
    },
    // {
    //   "id": "1219",
    //   "title": "ماکتل آرامش",
    //   "desciption": "شربت زعفران-بیدمشک-زعفران-گلگاوزبان",
    //   "price": "130",
    //   "image": none
    // },
    {
      "id": "1220",
      "title": "کافی لیموناد",
      "desciption": "اسپرسو-لیموناد",
      "price": "180",
      "image": none
    },
    // {
    //   "id": "1221",
    //   "title": "ماکتل باربی",
    //   "desciption": "آدامس بادکنکی-کاکتوس",
    //   "price": "140",
    //   "image": none
    // },
    // {
    //   "id": "1222",
    //   "title": "ماکتل ولنتاین",
    //   "desciption": "",
    //   "price": "150",
    //   "image": none
    // },
    {
      "id": "1223",
      "title": "melon",
      "desciption": "آب هندوانه+توت فرنگی+وانیل+شیر نارگیل",
      "price": "225",
      "image": melone
    },
    {
      "id": "1224",
      "title": "coco blood",
      "desciption": " آب نارگیل+پیناکولادا+آب انگور+آب آلوورا+نمک",
      "price": "205",
      "image": cocoblood
    },
    {
      "id": "1225",
      "title": "santiago",
      "desciption": "سیروپ‌نارگیل+بلوکارسائو+پیناکولادا+آلوئه‌ورا+خامه",
      "price": "205",
      "image": santiago
    },
    {
      "id": "1226",
      "title": "floriya",
      "desciption": "چای‌ترش+بلوکاراسائو+لیمو+آلوئه‌ورا",
      "price": "205",
      "image": floriya
    },
    {
      "id": "1227",
      "title": "pops",
      "desciption": "آلوورا+كرن بري+ليمو+پوره توت فرنگي",
      "price": "185",
      "image": pops
    },
    {
      "id": "1228",
      "title": "winio",
      "desciption": "چاي ترش با فلفل+آب انگور قرمز+آب ليمو+شاتوت+نمك",
      "price": "185",
      "image": winio
    },
    {
      "id": "1229",
      "title": "black moktel",
      "desciption": "سیروپ بلک + لیمو + اسپرایت + بلو کاراسوا",
      "price": "175",
      "image": none
    },
    {
      "id": "1230",
      "title": "تکیلا ماکتل",
      "desciption": "دلستر مالت + سیروپ تکیلا",
      "price": "210",
      "image": none
    },
    // {
    //   "id": "1231",
    //   "title": "تکیلا ماکتل",
    //   "desciption": "",
    //   "price": "195",
    //   "image": none
    // },
  ]